'use strict';

var LastAdjustmentTooltipController = function LastAdjustmentTooltipController($scope, ruleNavigationService) {
  $scope.navigateToRules = function (technicalId) {
    ruleNavigationService.navigateToRules(technicalId);
  };
};
LastAdjustmentTooltipController.$inject = ['$scope', 'RuleNavigationService'];
module.exports = LastAdjustmentTooltipController;